export default {
  props: {
    scrollY: Number,
  },
  mounted() {
    this.initAnimation();
    this.$on('loco-scroll-update', this.handleLocoScrollUpdate);
  },
  methods: {
    handleLocoScrollUpdate() {
      this.moveCircle();
    },
    initAnimation() {
      const cursor = this.$refs.cursor;
      const page = this.$refs.clickableContainer;
      const followArea = this.$el.querySelectorAll('.area-clickable');

      page.addEventListener('mousemove', (e) => {
        this.clientY = e.clientY;
        this.clientX = e.clientX;

        this.moveCircle();
      });

      followArea.forEach((el) => {
        el.addEventListener('mouseover', () => {
          this.$gsap.to(cursor, {
            duration: 0.25,
            scale: 1,
            autoAlpha: 1,
          });
        });

        el.addEventListener('mouseout', () => {
          this.$gsap.to(cursor, {
            duration: 0.25,
            scale: 0.5,
            autoAlpha: 0,
          });
        });

        el.addEventListener('mousedown', () => {
          this.$gsap.to(cursor, {
            duration: 0.5,
            css: {
              translate: '-50%, -50%',
              scale: 0.75
            },
          });
        });

        el.addEventListener('mouseup', () => {
          this.$gsap.to(cursor, {
            duration: 0.5,
            css: {
              translate: '-50%, -50%',
              scale: 1
            },
          });
        });
      });
    },
    moveCircle() {
      const cursor = this.$refs.cursor;
      let rotateLeft = false;

      if (!this.disableCustomCursorRotate && this.clientX > (window.innerWidth / 2)) {
        rotateLeft = true;
      }

      this.$gsap.to(cursor, {
        duration: 0.25,
        css: {
          left: this.clientX,
          top: this.scrollY + this.clientY,
          rotationY: rotateLeft ? 0 : 180
        },
      });
    },
  },
};
